export default __webpack_public_path__ + "static/media/home_cookies_first.5941ea35.jpg";